/* eslint-disable */
import React from 'react';

interface QuizIconProps extends React.SVGProps<SVGSVGElement> {}

export const PassDownloadIcon: React.FC<QuizIconProps> = ({
  className,
  ...props
}) => (
  <svg
    className={className}
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M42 30V38C42 39.0609 41.5786 40.0783 40.8284 40.8284C40.0783 41.5786 39.0609 42 38 42H10C8.93913 42 7.92172 41.5786 7.17157 40.8284C6.42143 40.0783 6 39.0609 6 38V30M34 20L24 30L14 20M24 30V6"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AgainIcon: React.FC<QuizIconProps> = ({ className, ...props }) => (
  <svg
    className={className}
    width={44}
    height={40}
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M14 15.9813H2V3.98134M2 15.9813L11.28 7.26134C14.0418 4.50418 17.6249 2.71928 21.4894 2.17558C25.3538 1.63187 29.2903 2.35881 32.7057 4.24687C36.1211 6.13493 38.8303 9.08183 40.4252 12.6435C42.0202 16.2053 42.4144 20.1888 41.5484 23.9941C40.6825 27.7993 38.6034 31.22 35.6243 33.7409C32.6452 36.2617 28.9275 37.746 25.0314 37.9703C21.1354 38.1945 17.272 37.1465 14.0233 34.9841C10.7747 32.8217 8.31679 29.6621 7.02 25.9813"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
